/**
 * widget-consent-styles — styling for the booking widget's consent opt-ins.
 * (Named `-styles.ts`, not `.css.ts`: the preview's module resolver doesn't
 * resolve a `.css` import specifier — same reason journeys-styles.ts exists.)
 *
 * WIDGET HARD RULE (CD-Docket 2026-08-04): the widget's markup carries ONLY
 * classes and ids, never inline styles, so a tenant can restyle or hide any part
 * of it from their own custom CSS. These rules are therefore
 *  - single-class / single-id selectors (lowest practical specificity),
 *  - free of `!important`,
 *  - injected into <head> as early as the component mounts, i.e. BEFORE the
 *    tenant's own stylesheet in document order, so an equally specific tenant
 *    rule wins the cascade.
 * Colour and type deliberately inherit (`currentColor`, `inherit`) so the block
 * picks up the journey theme without a single inline declaration; the accent is
 * read from --jrni-consent-accent when a theme sets one.
 */
let injected = false;
const CSS = `
.jrni-consent-optin{display:block;margin-top:10px}
.jrni-consent-optin__row{display:flex;gap:10px;align-items:flex-start;cursor:pointer;font-family:inherit}
.jrni-consent-optin__checkbox{flex-shrink:0;margin-top:2px;width:15px;height:15px;cursor:pointer;accent-color:var(--jrni-consent-accent,currentColor)}
.jrni-consent-optin__checkbox:disabled{cursor:default;opacity:.5}
.jrni-consent-optin__text{font-size:11.5px;line-height:1.5;color:inherit}
.jrni-consent-optin__hint{display:block;font-size:10px;line-height:1.5;margin:3px 0 0;opacity:.65}
.jrni-consent-optin__state{display:block;font-size:10px;line-height:1.5;margin:3px 0 0;opacity:.8}
`;

export function ensureWidgetConsentCss(): void {
  if (injected || typeof document === "undefined") return;
  injected = true;
  const st = document.createElement("style");
  st.id = "jrni-widget-consent-css";
  st.textContent = CSS;
  const head = document.head || document.documentElement;
  // Insert FIRST so tenant custom CSS (appended later) overrides without !important.
  if (head.firstChild) head.insertBefore(st, head.firstChild);
  else head.appendChild(st);
}
